import styled, { css } from 'styled-components';

import { Chevron2Icon } from '../../../assets';
import { ThemeProp } from '../../../theme/Themes';

export const MOBILE_TOP_MARGIN_ADJUSTMENT = '0.3rem';

interface ContainerProps {
  $mobilePadding?: string;
  $desktopPadding?: string;
  $tabletPadding?: string;
  $maxWidth?: string;
  $noOverflowLayout?: boolean;
  $shouldShowSurfaceBackground?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: ${(props: ContainerProps) => props.$maxWidth ?? '75rem'};
  padding: ${(props: ContainerProps) => props.$desktopPadding ?? '0 4rem'};
  align-self: center;

  ${(props: ContainerProps) =>
    props.$noOverflowLayout &&
    css`
      max-height: 100vh;
      overflow: hidden;
    `}

  ${(props: ThemeProp & ContainerProps) =>
    props.$shouldShowSurfaceBackground && `background: ${props.theme.colors.layout.surface.default};`}

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    padding: ${(props: ContainerProps) => props.$tabletPadding ?? '0 1.5rem'};
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: ${(props) => props.$mobilePadding ?? '4.75rem 1rem 0 1rem'};
  }
`;

export const Title = styled.span<any>`
  color: ${(props: ThemeProp) => props.theme.colors.greyscale.c050};
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.h2.fontSize};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.m};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  margin: 0;
  letter-spacing: normal;
  align-self: flex-start;
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: ${(props) => (props.mobile ? 'inline' : 'none')};
  }
`;

export const TitleContainer = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${(props) => (props.padding ? props.padding : '0 0 1.5rem 0')};

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: ${(props) => (props.padding ? props.padding : '1.5rem 0')};
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const GoBackChevron = styled(Chevron2Icon)`
  transform: rotate(90deg);
  stroke: ${(props) => props.theme.colors.primary.c300};
`;

export const ChevronContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 1.5rem;
  padding-right: 0.75rem;
  cursor: pointer;
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    visibility: hidden;
  }
`;
